import React from 'react'

function Content() {
    return (
        <div>
            <h1 className='main'>File Sharing App</h1>
            <hr style={{ width: '90%' }}></hr>
            <p className='con'>Upload file and Share the downlodable link</p>
        </div>
    )
}

export default Content
